import { render } from "./QwCheckbox.vue?vue&type=template&id=1225b0e6"
import script from "./QwCheckbox.vue?vue&type=script&lang=js"
export * from "./QwCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__